import React from "react";
import { Box } from "@mui/material";

/** The small green count next to a link, e.g. saved searches or unread messages. */
const CountBadge: React.FC<{ count: number }> = ({ count }) => (
  <Box
    component="span"
    sx={{
      bgcolor: "var(--accent)",
      color: "#fff",
      fontSize: 10,
      fontWeight: 700,
      px: 0.75,
      py: "1px",
      borderRadius: 999,
      minWidth: 16,
      textAlign: "center",
      lineHeight: 1.2,
    }}
  >
    {count}
  </Box>
);

export default CountBadge;
